<h2 mat-dialog-title>{{ 'AI_ASSISTANT.FUNCTIONS.ADD_FUNCTION.ADD_A_FUNCTION' | translate }}</h2>
<mat-dialog-content>
  <div class="functions-list">
    @if (!isLoading() || functions().length > 0) {
      <mat-card class="add-button capability-card" (click)="newFunction()">
        <mat-card-content>
          <mat-icon class="capability-icon">offline_bolt</mat-icon>
          <div class="new-Function-title">{{ 'AI_ASSISTANT.FUNCTIONS.ADD_FUNCTION.NEW_FUNCTION' | translate }}</div>
        </mat-card-content>
      </mat-card>
    }
    @for (aiFunction of functions(); track aiFunction.id) {
      <mat-card (click)="chooseFunction(aiFunction)" class="clickable-card capability-card">
        <mat-card-content>
          <mat-icon class="capability-icon">offline_bolt</mat-icon>
          <div class="function-name">
            {{ aiFunction.id }}
          </div>
          <div>
            {{ aiFunction.description }}
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>
  @if (isLoading()) {
    <glxy-loading-spinner></glxy-loading-spinner>
  }
  <glxy-infinite-scroll-trigger (isVisible)="loadFunctions()" />
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
</mat-dialog-actions>
